export interface SupportTicketPromptContext {
  version: string;
  surface: string;
  url: string;
  userAgent: string;
  timestamp: string;
}

export function buildSupportTicketPrompt(
  context: SupportTicketPromptContext,
): string {
  return [
    "Start the Fintheon support-ticket flow for an issue I am about to describe.",
    "",
    "Version context:",
    `- Version: ${context.version}`,
    `- Surface: ${context.surface}`,
    `- URL: ${context.url}`,
    `- User agent: ${context.userAgent}`,
    `- Started: ${context.timestamp}`,
    "",
    "Support protocol:",
    "1. Give a brief plan and ask no more than two discovery questions if the issue is unclear.",
    "2. Build a concise ticket preview with title, type, severity, impact, reproduction, expected behavior, actual behavior, and version context.",
    "3. Show the preview with open_right_rail using title `Ticket Preview` and surface `report` so it renders as the Streamdown preview surface.",
    "4. Ask for final approval with ask_approval_questions. The approval question must ask the user to approve filing this exact ticket or request changes.",
    "5. Only after explicit approval, call file_linear_support_ticket with approvedByUser true and source `app-user`. Use the Fintheon Linear workspace from server-side Linear configuration. Never expose tokens.",
    "6. Do not invent a ticket number. The server assigns the next FS support prefix from Linear.",
  ].join("\n");
}
